import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { FIELD_TYPES } from "../DynamicField/Tasks/utils/utils";
import { getLastUpdatedTootlTip } from "../../pages/new-dashboard/dashboard-util/dashboard-utils";
import DynamicFieldBulkRow from "./DynamicFieldBulkRow";
import "../../pages/new-dashboard/dashboard-consumer-retail/dashboard-consumer-retail.scss"
import "./DynamicFieldBulk.scss";

const DynamicFieldBulkTable = ({
    originalData,
    hasProjectColumn,
    hasMemberColumn,
    hasDueDate,
    columnNamesNotNeeded,
    onSave,
    widgetName,
}) => {
    const [editMode, setEditMode] = useState(false);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [data, setData] = useState(originalData);
    const [dynamicFieldsBulk, setDynamicFieldsBulk] = useState([]);
    const isRealEstate = widgetName === "RealEstate";

    useEffect(() => {
        setData([...originalData]);
    }, [originalData]);

    const onCancel = () =>  {
        setData([...originalData]);
    }

    const setDynamicFieldsBulkfunc = (values) => {
        let mainArray = dynamicFieldsBulk;
        for (let i =0; i< values.length; i++) {
            let flag = false;
            for (let j =0; j< dynamicFieldsBulk.length; j++) {
                if (values[i].Id == dynamicFieldsBulk[j].Id) {
                    flag= true;
                    mainArray[j].DynamicFields = values[i].DynamicFields;

                    if (isRealEstate) {
                        mainArray[j].Note = values[i].Note == null ? "" : values[i].Note;
                    }
                }
            }

            if (!flag) mainArray.push(values[i]);
        }

        setDynamicFieldsBulk(mainArray);
    }

    return (
        <div className="dynamicBulk">
            <div className={editMode ? "editRow editMode" : "editRow"}>
                {   editMode
                    ? <div>Edit Mode</div>
                    : <div></div>
                }
                <div>
                    {   editMode &&
                        <span className="editRowCancel" onClick={() => { setEditMode(false); onCancel()}}>
                            Cancel
                        </span>
                    }
                    {   !editMode &&
                        <button className="editRowButton" onClick={() => setEditMode(true)}>
                            Edit
                        </button>
                    }
                    {   editMode &&
                        <button className={saveDisabled ? "editRowButtonDisabled" : "editRowButton"}
                            onClick={() => {
                                setEditMode(false);

                                onSave(dynamicFieldsBulk)}

                            }
                            disabled={saveDisabled}>
                            Save
                        </button>
                    }
                </div>
            </div>
            <table className="dashboard-table table">
                <thead className="header">
                    <tr>
                        {   hasProjectColumn &&
                            <th className="col-md-2 text-break">
                                {isRealEstate ? "Deal" : "Project" }
                            </th>
                        }
                        {   hasMemberColumn &&
                            <th className="col-md-2 text-break">
                                Members
                            </th>
                        }
                        {   hasDueDate &&
                            <th className="col-md-1 text-break">
                                Due Date
                            </th>
                        }
                        {   data[0] && data[0]?.DynamicFields.filter(x => {
                            if (!columnNamesNotNeeded.includes(x.Label)) return x;
                            }).map(df =>
                                <th key={df.Id || df.Label} className={`col-md-${isRealEstate ? "1" : "2 text-break"}`}>
                                    {(df.LabelShort == null || df.LabelShort == "") ? df.Label : df.LabelShort}
                                </th>
                            )
                        }
                        {   isRealEstate ?
                                <th className="col-md-2">Last Updated</th>
                            :
                                getLastUpdatedTootlTip(<th className="col-md-2">Last Updated</th>)
                        }
                        {   isRealEstate &&
                            <th className="col-md-2">
                                Comments
                            </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {data && data.map(row =>
                        <DynamicFieldBulkRow
                            data={data}
                            row={row}
                            hasProjectColumn={hasProjectColumn}
                            hasMemberColumn={hasMemberColumn}
                            hasDueDate={hasDueDate}
                            columnNamesNotNeeded={columnNamesNotNeeded}
                            editMode={editMode}
                            setSaveDisabled={setSaveDisabled}
                            setDynamicFieldsBulkfunc={setDynamicFieldsBulkfunc}
                            isRealEstate={isRealEstate}
                        />
                    )}
                </tbody>
            </table>
        </div>
    );
};

DynamicFieldBulkTable.propTypes = {
    originalData: PropTypes.arrayOf(
        PropTypes.shape({
            Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            DynamicFields: PropTypes.arrayOf(
                PropTypes.shape({
                    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                    Label: PropTypes.string.isRequired,
                    Data: PropTypes.any,
                    touched: PropTypes.bool,
                    FieldType: PropTypes.oneOf(Object.values(FIELD_TYPES)),
                    FieldMask: PropTypes.string,
                    FieldRegexDescription: PropTypes.string,
                })
            ).isRequired,
            Note: PropTypes.string,
            Project: PropTypes.shape({
                Name: PropTypes.string,
                OwnerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                Members: PropTypes.array,
                Start: PropTypes.string,
                End: PropTypes.string,
            }),
            LastUpdatedString: PropTypes.string,
        })
    ).isRequired,
    hasProjectColumn: PropTypes.bool,
    hasMemberColumn: PropTypes.bool,
    hasDueDate: PropTypes.bool,
    columnNamesNotNeeded: PropTypes.arrayOf(PropTypes.string),
    onSave: PropTypes.func.isRequired,
    widgetName: PropTypes.string,
};

export default DynamicFieldBulkTable;
